import initialState from "./initialState";
import {BOOK_ADDED, BOOK_EDITED, BOOK_LOADED, BOOK_REMOVED} from "./actionTypes";

const bookReducer = (state = initialState, action) => {
    switch (action.type) {
        case BOOK_LOADED:
            return  action.payload;
        
        case BOOK_ADDED:
            return [...state, action.payload];
            
        case BOOK_REMOVED:
            return state.filter(b => b.id !== action.payload);
            
        case BOOK_EDITED:
            const others = state.filter(b => b.id !== action.payload.id);
            return [...others, action.payload];
            
        default:
            return state;
    }
}

export default bookReducer;